import React, { useState } from "react";
import { useTheme } from "../../context/ThemeContext";
import Typewriter from "typewriter-effect";

import { BsFillMoonStarsFill, BsFillSunFill } from "react-icons/bs";
import { IoDocumentTextOutline } from "react-icons/io5";
import { FaLinkedinIn } from "react-icons/fa";
import "./home.css";
import { Fade } from "../../components/Animation/AnimationWrapper";

const Home = () => {
  const [theme, setTheme] = useTheme();

  //handle theme
  const handleTheme = () => {
    setTheme((prevState) => (prevState === "light" ? "dark" : "light"));
  };
  return (
    <>
      <div className="container-fluid home-container" id="home">
        <div className="theme-btn" onClick={handleTheme}>
          {theme === "light" ? (
            <BsFillMoonStarsFill size={30} />
          ) : (
            <BsFillSunFill size={30} />
          )}
        </div>

        {/* Animated background particles */}
        <div className="particles">
          <span className="particle"></span>
          <span className="particle"></span>
          <span className="particle"></span>
          <span className="particle"></span>
          <span className="particle"></span>
        </div>

        <div className="home-content-wrapper">
          <div className="home-content-left">
            <Fade right>
              <div className="greeting-section">
                <h2 className="greeting-text">Hi, I'm</h2>
              </div>
              <h1 className="name-heading">Himanshu Kumar</h1>
              <div className="typewriter-container">
                <span className="code-bracket">&lt;</span>
                <Typewriter
                  options={{
                    strings: [
                      "FullStack Developer",
                      "MERN Stack Developer",
                      "React Native Developer",
                      "App Developer",
                      "React Developer",
                      "Open Source Enthusiast",
                    ],
                    autoStart: true,
                    loop: true,
                    deleteSpeed: 50,
                    delay: 80,
                  }}
                />
                <span className="code-bracket">/&gt;</span>
              </div>
              <p className="hero-description">
                <span className="highlight-text">MERN Stack & React Native Developer</span> | Technical Lead @ Knowledge-Bubble |
                <span className="trophy-text"> Envisage'25 Winner</span> | App Developer @ Jabsz Studios |
                Ex-Intern @ Innomatics Research Labs | Learning DevOps
              </p>
            </Fade>
            <Fade bottom>
              <div className="home-buttons">
                <a
                  className="btn btn-hire"
                  href="https://www.linkedin.com/in/vashist-himanshu/"
                  rel="noreferrer"
                  target="_blank"
                >
                  <span className="btn-text">Connect on LinkedIn</span>
                  <span className="btn-icon"><FaLinkedinIn /></span>
                </a>
                <a
                  className="btn btn-cv"
                  href="https://drive.google.com/file/d/1y8zKaMImNBg_FJzYHAHLniMkjKkD8OQc/view?usp=sharing"
                  rel="noreferrer"
                  target="_blank"
                >
                  <span className="btn-text">View Resume</span>
                  <span className="btn-icon"><IoDocumentTextOutline /></span>
                </a>
              </div>
            </Fade>
          </div>
          <div className="home-content-right">
            <Fade left>
              <div className="profile-image-container">
                <img src="1.jpg" alt="Himanshu Kumar" className="profile-image" />
                <div className="image-border-glow"></div>
              </div>
            </Fade>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
